// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2wN7S","legacyBtn":"MutateMid_legacyBtn__1M4Vz"};